module.exports = __webpack_public_path__ + "img/loader.c5b7591a.svg";